"use strict";

//import 'jquery'

import { isIE } from './utils/isIE'

if((window.devicePixelRatio || 1) > 2){
  $('body').addClass('high-device-pixel-ratio')
}

if(isIE()) {

  let ieHTML = $("#no-ie-support").html()
  $('body').html(ieHTML)

} else {

  require('./setup')
  require('./cookie')
  require('./fbq')
  require('./menu')
  require('./locomotive-scroll')
  require('./popup')
  require('./popup-video')
  require('./popup-methodology')
  require('./rankings')
  require('./blocks/intro')
  require('./blocks/partners')
  require('./blocks/news')
  require('./blocks/rankings-top-five')
  require('./blocks/faq')
  require('./partials/news/categories-filter')

}




